import { formatSIMC, relativeTime } from './format.js';

export function createTable(container, { onOpenTx } = {}) {
  container.innerHTML = `
    <table>
      <thead>
        <tr>
          <th>De</th>
          <th>Para</th>
          <th>Valor (SIMC)</th>
          <th>Quando</th>
          <th>Tx</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  `;
  const tbody = container.querySelector('tbody');

  function render(store) {
    const rows = [...store.payments].reverse().slice(0, 200);
    tbody.innerHTML = rows
      .map((p) => {
        const from = store.nodes.get(p.from)?.agent;
        const to = store.nodes.get(p.to)?.agent;
        return `
          <tr>
            <td>${from ? `${from.emoji} ${from.name}` : p.from}</td>
            <td>${to ? `${to.emoji} ${to.name}` : p.to}</td>
            <td class="tabular-nums">${formatSIMC(p.value)}</td>
            <td class="tabular-nums">${relativeTime(p.timestamp)}</td>
            <td><button type="button" class="tx-link" data-tx-hash="${p.hash}">ver</button></td>
          </tr>
        `;
      })
      .join('');

    if (!rows.length) {
      tbody.innerHTML = `<tr><td colspan="5" style="color:var(--ink-muted);">Nenhum pagamento ainda.</td></tr>`;
    }
  }

  tbody.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-tx-hash]');
    if (btn) onOpenTx?.(btn.dataset.txHash);
  });

  return { render };
}
